module.exports = __webpack_public_path__ + "static/img/li_top1.73ccc0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/li_top1.png
// module id = QO6H
// module chunks = 1